import _ from 'lodash';
import React from 'react';
import FightCard from '~/src/components/shared/FightCard';
import SectionHeading from '~/src/components/shared/SectionHeading';
import { OtxEvent } from '~/src/models/OtxEvent';
import { OtxFight } from '~/src/models/OtxFight';
import './FightCards.scss';

const FightCards = ({ event, tournamentFights }: { event: OtxEvent; tournamentFights: OtxFight[] }) => {
	if (event.otx_fights.length > 0) {
		return (
			<section className="events-fight-cards">
				<SectionHeading>Fight Card</SectionHeading>
				<div className="cards">
					{_.orderBy(event.otx_fights, (f) => f.starts_at)
						.reverse()
						.map((fight) => (
							<FightCard key={fight.id} fight={fight} tournamentFights={tournamentFights} />
						))}
				</div>
			</section>
		);
	}

	return <></>;
};

// Note: There can only be one export per page component for hot loading to work
export default FightCards;
